import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { withRouter } from 'react-router';


class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      isRegister: true,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleRegisterClick = this.handleRegisterClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    this.handleRegisterSubmit = this.handleRegisterSubmit.bind(this);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleLoginClick() {
    this.setState({isRegister:false, show:true,})
  }

  handleLogoutClick() {
    this.props.onLogout();
    this.props.history.push(`/`);
  }

  handleRegisterClick() {
    this.setState({isRegister:true, show:true,})
  }

  handleInputChange(event) {
    this.props.onLogFormInputChange(event);
  }

  handleRegisterSubmit(event) {
    this.props.onRegister(event);
    this.setState({show:false,})
  }

  handleLoginSubmit(event) {
    this.props.onLogin(event);
    this.setState({show:false,});
    this.props.history.push(`/`);
  }

  render() {
    return (
      <div style={{'align':'left'}}>
        <small className="userinfo">
          {!this.props.isLogin?
            (<span>请<a href="javascript:;" onClick={this.handleLoginClick} >登录</a>或<a href="javascript:;" onClick={this.handleRegisterClick} >注册</a></span>)
            :
            (<span>欢迎您，{this.props.username}&nbsp;<a href="javascript:;" onClick={this.handleLogoutClick}>注销</a></span>)
          }
        </small>
        <h2>鲁教2013版五四学制初中英语单词同步测试练习</h2>
        <p>共<b>7</b>册，<b>62</b>个单元，<b>2435</b>个单词和短语，<b>1750</b>个重点单词。注册账户并登录使用可以保存您的历史数据。</p>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.isRegister?('请注册'):('请登录')}</Modal.Title>
          </Modal.Header>
          <form>
          <Modal.Body>
              <fieldset>
                <label htmlFor="username">用户名{this.state.isRegister?('（字母或数字组合，不可用中文）'):('')}<br/>
                <input id="username" placeholder="用户名" onChange={this.handleInputChange} /></label><br />
                {
                  this.state.isRegister?
                    (<label htmlFor="email">邮箱<br/>
                    <input id="email" placeholder="user@example.com" onChange={this.handleInputChange} /></label>)
                  : ('')
                }
                <br />
                <label htmlFor="password">密码{this.state.isRegister?('（长度最少8位，请牢记）'):('')}<br/>
                <input id="password" placeholder="密码" type="password" onChange={this.handleInputChange} /></label><br />
              </fieldset>
          </Modal.Body>
          <Modal.Footer>
            {
              this.state.isRegister ?
                (<Button onClick={this.handleRegisterSubmit}>注册</Button>)
                :
                (<Button onClick={this.handleLoginSubmit}>登录</Button>)
            }
          </Modal.Footer>
          </form>
        </Modal>
      </div>
    )
  }
}


export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/Header.js